export enum LodResourceType {
    none = 0,
    cSV = 1,
    rDFa = 2,
    xMLRDF = 3,
    jSONLD = 4,
}
